export default "__VITE_ASSET__BA34QegB__"